import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class BaseDialog extends Vue {
	@Prop({default: null})
	public readonly header!: string | null
}
